import React, { useState } from 'react';
import AuthShell from './AuthShell';
import { useNavigate } from 'react-router-dom';

const EyeIcon = ({ visible }) =>
  visible ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  );

const CreateNewPasswordFront = ({ resetEmail }) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showMatchError, setShowMatchError] = useState(false);
  const [showRequirementError, setShowRequirementError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const handleConfirmChange = async () => {
    // Max raised to 64 (NIST SP 800-63B) and hyphen added to support Apple/Samsung auto-generated passwords
    const requirementRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-!@#$%^&*(),.?":{}|<>]).{8,64}$/;
    const meetsRequirements = requirementRegex.test(password);
    const passwordsMatch = password === confirmPassword && password !== "";

    if (meetsRequirements && passwordsMatch) {
      try {
        const response = await fetch("https://vicktoria.ai/api/reset-password", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: resetEmail.trim().toLowerCase(),
            password: password
          }),
        });

        if (response.ok) {
          alert("Password successfully changed!");
          navigate('/login');
        } else {
          const result = await response.json();
          alert(result.error || "Reset failed.");
        }
      } catch (err) {
        alert("Server error. Please try again later.");
      }
    } else {
      setShowRequirementError(!meetsRequirements);
      setShowMatchError(!passwordsMatch);
    }
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '15px'
  };

  const inputStyle = {
    width: '100%',
    maxWidth: '300px',
    padding: '10px 36px 10px 10px',
    borderRadius: '8px',
    border: '2px solid #D1DEE6',
    backgroundColor: '#F8FAFC',
    textAlign: 'center',
    fontSize: '16px',
    outline: 'none',
    boxSizing: 'border-box',
  };

  const eyeBtnStyle = {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    color: '#2B4B6F',
    display: 'flex',
    alignItems: 'center',
  };

  return (
    <AuthShell title="Create New Password">
      <div style={formStyle}>
        <p style={{ color: '#2B4B6F', fontSize: '16px', marginBottom: '10px' }}>
          Please create your new password
        </p>

        <div style={{ position: 'relative', width: '100%', maxWidth: '300px' }}>
          <input
            type={showPassword ? "text" : "password"}
            style={inputStyle}
            placeholder="**********"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button style={eyeBtnStyle} onClick={() => setShowPassword(!showPassword)} type="button" tabIndex={-1}>
            <EyeIcon visible={showPassword} />
          </button>
        </div>

        <label style={{ color: '#2B4B6F', fontSize: '16px', fontWeight: '500' }}>
          Retype Password
        </label>

        <div style={{ position: 'relative', width: '100%', maxWidth: '300px' }}>
          <input
            type={showConfirmPassword ? "text" : "password"}
            style={inputStyle}
            placeholder="**********"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <button style={eyeBtnStyle} onClick={() => setShowConfirmPassword(!showConfirmPassword)} type="button" tabIndex={-1}>
            <EyeIcon visible={showConfirmPassword} />
          </button>
        </div>

        {/* Dynamic Errors based on logic above */}
        {showMatchError && (
          <div style={{ color: '#D0021B', fontSize: '13px' }}>Passwords must match</div>
        )}

        {showRequirementError && (
          <div style={{ color: '#D0021B', fontSize: '13px', maxWidth: '280px', textAlign: 'center' }}>
            Password must be 8–15 characters with 1 uppercase, 1 lowercase, 1 number, and 1 special character.
          </div>
        )}

        <button
          style={{
            backgroundColor: '#4A8EB3', color: 'white', border: 'none',
            padding: '12px 35px', borderRadius: '12px', fontSize: '18px',
            fontWeight: 'bold', cursor: 'pointer', marginTop: '15px'
          }}
          onClick={handleConfirmChange}
        >
          Confirm Password Change
        </button>

        <span
          style={{ color: '#2B4B6F', cursor: 'pointer', fontSize: '14px', textDecoration: 'underline', marginTop: '20px' }}
          onClick={() => navigate('/login')}>
          Back to Login
        </span>
      </div>
    </AuthShell>
  );
};

export default CreateNewPasswordFront;
